import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE AUTONOMOUS CHILD VISUAL SYSTEM™',
  ideal: 'Families with children ages 3-12 who want the routine to be visible instead of repeated',
  was: '$54',
  now: '$27',
  features: ['Complete 50-page eBook (A4, print-ready)', '6 routine volumes (Wake Up → Sleep)', 'Visual templates, icons & flashcards', 'Parent scripts & progress trackers', '5 Free Bonuses included', '30-Day Challenge protocol'],
  cta: 'Get the visual system now'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-135" data-mp="3cao1g22j5x22">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-136" data-mp="4t5lrddrd9yk">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-blush/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(124,58,237,0.4)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-137" data-mp="9si9s1gd8n2q">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-138" data-mp="3n5kbkpr56ip9">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-139" data-mp="3ryn5x03qtw6i">
            <span className="font-semibold text-plum/80" data-id="element-140" data-mp="2uihc9ven63xy">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-141" data-mp="2zhkgjdmss64v">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-142" data-mp="2zgivqhfzc59y">{plan.was}</span>
            <div className="text-grape-shine font-display text-4xl font-black" style={{
            fontSize: "72px",
            paddingBottom: "26px",
            fontFamily: "Montserrat, sans-serif",
            paddingTop: "20px",
            fontWeight: "800"
          }} data-id="element-143" data-mp="2rf1pbnnyes0g">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-blush" data-id="element-144" data-mp="2w7l58ra45z8f">
              One-time payment · No monthly subscription
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" style={{
            fontWeight: "600"
          }} data-id="element-145" data-mp="28j1xqdyw1qhe">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-146" data-mp="2ih7y2r51qok5">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-147" data-mp="2dgtzs0t8yszb">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-148" data-mp="3tv3gc8r8zdfl" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-149" data-mp="3ovqpze163o89">
            <CTAButton size="md" data-id="element-150" data-mp="9ud62j84lip">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-151" data-mp="cq8dj3osw3g">
            You save $27 USD (50% OFF)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-152" data-mp="3nfv4caxbmbpw">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-153" data-mp="j1542joy8yal">
                <Icon className="h-4 w-4 text-grape" data-id="element-154" data-mp="j37rqx2mqfc5" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-155" data-mp="a9cwcgrb839p" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-156" data-mp="a81redm4oph0">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-157" data-mp="11zr5jzodorf1" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-158" data-mp="11xmosh5drxxc">
            <span className="font-display font-bold text-plum" data-id="element-159" data-mp="16r95ckeo0lyf">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the system does not fit your family or does not
            make your routine simpler, request your refund and we return 100% of your money. We
            want you to try it with complete peace of mind, risk-free.
          </p>
        </div>
      </div>
    </section>;
}